export const THEMES = [
  {
    id: "lavender",
    name: "Lavender",
    bg1: "#f3e9ff",
    bg2: "#e9d8ff",
    surface: "#f9f4ff",
    text: "#544274",
    accent: "#b59aff",
    chip: "#e3d6ff"
  },
  {
    id: "sky",
    name: "Sky Blue",
    bg1: "#e6f4ff",
    bg2: "#cfe7ff",
    surface: "#f5faff",
    text: "#27507d",
    accent: "#7fc4ff",
    chip: "#d7ecff"
  },
  {
    id: "mint",
    name: "Mint Green",
    bg1: "#e8fff3",
    bg2: "#d0f7e2",
    surface: "#f4fff9",
    text: "#2f6a54",
    accent: "#7ae8b7",
    chip: "#d6faeb"
  },
  {
    id: "bubblegum",
    name: "Bubblegum Pink",
    bg1: "#ffe8f4",
    bg2: "#ffd1e7",
    surface: "#fff4f9",
    text: "#7c355d",
    accent: "#ff9dc9",
    chip: "#ffd8ec"
  },
  {
    id: "banana",
    name: "Banana Yellow",
    bg1: "#fff7d9",
    bg2: "#ffe7a8",
    surface: "#fffae8",
    text: "#7a5b16",
    accent: "#ffd55f",
    chip: "#ffe9ac"
  },
  {
    id: "sunset",
    name: "Sunset Orange",
    bg1: "#ffe7d9",
    bg2: "#ffc9a5",
    surface: "#fff3eb",
    text: "#7f3f1f",
    accent: "#ff9b5f",
    chip: "#ffd7be"
  }
];

export const DEFAULT_THEME_ID = "lavender";
